<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_199_4114)">
      <rect
        width="36"
        height="36"
        rx="18"
        fill="#EEF1F4"
      />
      <path
        d="M31.4999 38.1377V34.7627C31.4999 32.9725 30.7888 31.2556 29.5229 29.9897C28.257 28.7239 26.5402 28.0127 24.75 28.0127H11.25C9.45978 28.0127 7.74289 28.7239 6.47702 29.9897C5.21116 31.2556 4.5 32.9725 4.5 34.7627V38.1377H31.4999Z"
        fill="#CACACA"
        stroke="#CACACA"
        stroke-width="3.37499"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.75 14.5127C24.75 18.2406 21.7279 21.2627 18 21.2627C14.2721 21.2627 11.25 18.2406 11.25 14.5127C11.25 10.7848 14.2721 7.7627 18 7.7627C21.7279 7.7627 24.75 10.7848 24.75 14.5127Z"
        fill="#CACACA"
        stroke="#CACACA"
        stroke-width="3.37499"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_199_4114">
        <rect
          width="36"
          height="36"
          rx="18"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>